import { useNavigate } from 'react-router-dom';
import { default as Box } from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import { MenuLinkTitle } from 'components/MenuLink';
import {
  AppLocale,
  getLocaleLanguage,
  getTrans,
  initIntl,
  setCurrentLocale
} from 'modules/i18n';
import { primary } from 'modules/minimal-ui-theme/theme/palette';
import { LanguageOptionWrapper } from './styledComponents';

export const LanguageSwitcher = () => {
  const appLocale = getLocaleLanguage();
  const navigate = useNavigate();

  const handleSelectLanguage = async (locale: string) => {
    setCurrentLocale(locale);
    await initIntl(locale);
    navigate(-1);
  };

  const getCustomStyles = (appLocale: string, value: string) => {
    const sxStyles = {
      backgroundColor: alpha(primary.main, 0.08),
      '& p': { color: primary.main }
    };

    return appLocale === value ? sxStyles : {};
  };

  return (
    <Box>
      <LanguageOptionWrapper
        onClick={() => handleSelectLanguage(AppLocale.en_US)}
        sx={getCustomStyles(appLocale, AppLocale.en_US)}
        data-testid={`lng-option-wrapper-${AppLocale.en_US}`}
      >
        <MenuLinkTitle data-testid={`lng-option-${AppLocale.en_US}`}>
          {getTrans('language.english')}
        </MenuLinkTitle>
      </LanguageOptionWrapper>
      <LanguageOptionWrapper
        onClick={() => handleSelectLanguage(AppLocale.de_DE)}
        sx={getCustomStyles(appLocale, AppLocale.de_DE)}
        data-testid={`lng-option-wrapper-${AppLocale.de_DE}`}
      >
        <MenuLinkTitle data-testid={`lng-option-${AppLocale.de_DE}`}>
          {getTrans('language.german')}
        </MenuLinkTitle>
      </LanguageOptionWrapper>
    </Box>
  );
};
